









































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { PrepTask } from '@/models'
import ApiClient from '@/services/api-client'
import { REQUEST_PLACEHOLDER_PREP, REQUEST_PLACEHOLDER_PROJECT, autoCheckName, showPrepError } from '@/utils/production-prep'

type AreaOption = { id: number; name: string }

/**
 * Form of a task of the catalog or of a preparation. It emits `save` with the task (empty links
 * left out) and a `done` callback: the parent saves it and calls `done(true)` to close the modal
 */
@Component
export default class UpsertPrepTaskModal extends Vue {
  @Prop({ required: false }) task: PrepTask | null
  @Prop({ required: true }) areas: AreaOption[]

  private form: PrepTask = UpsertPrepTaskModal.emptyTask(0)
  private saving = false
  // The help text shows the placeholders the request texts accept
  private placeholders = { proyecto: REQUEST_PLACEHOLDER_PREP, proyecto_ccp: REQUEST_PLACEHOLDER_PROJECT }
  private autoCheckKeys: string[] = []

  async created() {
    try {
      this.autoCheckKeys = await ApiClient.getPrepAutoChecks()
    } catch (error) {
      showPrepError(this, error)
    }
  }

  /** None, the checks there are and, if the task has one this app doesn't know yet, that one too */
  get autoCheckOptions(): { value: string; text: string }[] {
    const current = this.form.autoCheck
    const keys = current && !this.autoCheckKeys.includes(current) ? [...this.autoCheckKeys, current] : this.autoCheckKeys
    return [
      { value: '', text: this.$t('production_prep.auto_check.none').toString() },
      ...keys.map(key => ({ value: key, text: autoCheckName(this, key) }))
    ]
  }

  private static emptyTask(areaId: number): PrepTask {
    return { id: 0, areaId, name: '', description: '', required: true, requestText: '', links: [], autoCheck: '', sortOrder: 0 }
  }

  get isNew(): boolean {
    return !this.task || !this.task.id
  }

  get formOk(): boolean {
    return !!this.form.name.trim() && !!this.form.areaId &&
      this.form.links.every(link => !link.url.trim() || this.isValidUrl(link.url))
  }

  isValidUrl(url: string): boolean {
    return /^https?:\/\//.test(url.trim())
  }

  resetForm() {
    this.saving = false
    const task = this.task || UpsertPrepTaskModal.emptyTask(this.areas.length ? this.areas[0].id : 0)
    this.form = {
      ...task,
      description: task.description || '',
      requestText: task.requestText || '',
      autoCheck: task.autoCheck || '',
      links: (task.links || []).map(link => ({ ...link }))
    }
  }

  save() {
    if (!this.formOk || this.saving) return
    this.saving = true
    const task = { ...this.form, links: this.form.links.filter(link => link.url.trim()) }
    this.$emit('save', task, (saved: boolean) => {
      this.saving = false
      if (saved) this.$bvModal.hide('UpsertPrepTaskModal')
    })
  }
}
